// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2QW2s","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1t9aX"};